<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75ZM9.625 8.40625H7.65625V10.375C7.65625 10.7578 7.35547 11.0312 7 11.0312C6.61719 11.0312 6.34375 10.7578 6.34375 10.375V8.40625H4.375C3.99219 8.40625 3.71875 8.13281 3.71875 7.75C3.71875 7.39453 3.99219 7.09375 4.375 7.09375H6.34375V5.125C6.34375 4.76953 6.61719 4.46875 7 4.46875C7.35547 4.46875 7.65625 4.76953 7.65625 5.125V7.09375H9.625C9.98047 7.09375 10.2812 7.39453 10.2812 7.75C10.2812 8.13281 9.98047 8.40625 9.625 8.40625Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  fill: String,
});
</script>
